import { SegmentedControl, SegmentedControlOption } from '../../cdl/SegmentedControl/SegmentedControl';
import { translate } from '../../common/helpers/translate.helper';

import { SortingKey } from './SortingKey';

interface DemandSortingSegmentedControlProps {
    value: SortingKey;
    onChange: (newValue: SortingKey) => void;
}

export const DemandSortingSegmentedControl = (props: DemandSortingSegmentedControlProps) => {
    const options: SegmentedControlOption<SortingKey>[] = [
        {
            value: SortingKey.DAYS_LEFT_SAILING,
            label: translate('demand.select.daysLeftSailing'),
        },
        {
            value: SortingKey.NEXT_KEY_PORT,
            label: translate('demand.select.nextKeyPort'),
        },
    ];

    return <SegmentedControl options={options} value={props.value} onChange={props.onChange} />;
};
